// PLZ-325: utilidades del flujo "Pide y Recoge".

// Enlace a Google Maps para llegar a la sede. Usa coordenadas si la sede las tiene;
// si no, la direccion escrita. Devuelve "" si no hay con que armarlo.
export const directionsLink = (place) => {
    if (!place) return "";
    const lat = Number(place.latitude);
    const lng = Number(place.longitude);
    if (lat && lng) {
        return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
    }
    const text = [place.address, place.city].filter(Boolean).join(", ");
    return text ? `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(text)}` : "";
};

// La orden es de recoger en tienda (detail-order devuelve delivery_form desde PLZ-325).
export const isPickupOrder = (detailOrder) => Number(detailOrder?.delivery_form) === 2;
